// Admin → Responsive Preview: show the app in a chosen language (localization audit,
// Part 2, 2026-11-03). The preview frame (or its "Open at full browser size" window) is
// named "l10n-preview:<lang>"; a window's name survives clicking through the app inside
// it, unlike a ?query. Only that tool names a window so, so a normal tab is never
// affected. Display only: the account's saved language never changes (see below).

export const PREVIEW_LANGS = ["en", "pt-BR", "es-419", "fr-CA"];
const PREFIX = "l10n-preview:";

export function previewFrameName(lang) {
  return PREVIEW_LANGS.includes(lang) ? `${PREFIX}${lang}` : "";
}

export function previewLanguage(win = typeof window !== "undefined" ? window : null) {
  try {
    if (!win) return null;
    const name = String(win.name || "");
    if (!name.startsWith(PREFIX)) return null;
    const lang = name.slice(PREFIX.length);
    return PREVIEW_LANGS.includes(lang) ? lang : null;
  } catch {
    return null;
  }
}

const isPlainObject = (v) => v && typeof v === "object" && !Array.isArray(v) && !(v instanceof Blob);

/** The response with the account's and the interview's language swapped for the preview's. */
export function withPreviewLanguage(data, lang) {
  if (!lang || !isPlainObject(data)) return data;
  const swap = (obj) => {
    const out = { ...obj };
    if ("preferred_language" in out) out.preferred_language = lang;
    if ("interface_language" in out || "session_id" in out) out.interface_language = lang;
    return out;
  };
  const out = swap(data);
  for (const key of ["user", "session"]) if (isPlainObject(out[key])) out[key] = swap(out[key]);
  return out;
}

/** A save from inside the preview keeps the account's real language: the shown one is
 * only the preview's. Starting a test interview is unaffected (it is in the preview language). */
export function withoutPreviewLanguageWrite(config) {
  const method = String(config?.method || "get").toLowerCase();
  const body = config?.data;
  if (method === "get" || !isPlainObject(body) || !("preferred_language" in body)) return config;
  const { preferred_language: _ignored, ...rest } = body;
  return { ...config, data: rest };
}
